import * as Sentry from "@sentry/react";

export const sendSentryError = (message: string) => {
  return Sentry.captureMessage(message);
};

export const logSentryUser = ({
  clientId,
  clientName,
  environment,
}: {
  clientId: string;
  clientName: string;
  environment: string;
}) => {
  Sentry.setUser({ id: clientId, userName: `${clientName}-${environment}` });
};

export const resetSentryUser = () => {
  Sentry.setUser(null);
};

export const setSentryContext = (params: Record<string, string>) => {
  Sentry.setContext("Bridge-Init", params);
};
